import { ApiProperty } from '@nestjs/swagger';

import { UpdateInputModel } from './update-input.model';

export class FilesInputModel extends UpdateInputModel {
  @ApiProperty({ type: [String], format: 'binary' })
  public files!: any[];
}
